/* app/ui/track/util */

import $ from 'jquery';
import { Universal as Analytics } from 'App/track/analytics/universal';

var selectors = {};

var Track = {
	init: function () {},

	publishEvent: function ( data ) {
		Analytics.sendEvent( data );
	},

	publishPage: function ( data ) {
		Analytics.sendPageView( data );
	}
};

export { Track as Util };
